<template>
	<transition 
		v-on:leave="leave"
		v-on:after-leave="afterLeave"
		v-bind:css="false"
	>
		<div class="loader" v-if="!loaded" :class="{ready: ready}">
			<div class="loader-container container">
				<div class="preload-heading heading">Derek Tan</div>
				<div class="preload-text tag" :class="{cycle: preload.loadCycle}">Loading...</div>
			</div>
		</div>
	</transition>
</template>

<script>
import gsap from 'gsap';
import SplitText from 'gsap/SplitText';
import { mapGetters, mapActions } from 'vuex';

export default {	
	data() {
		return {
			ready: false,
			preload: {
				"images": false,
				"loadCycle": false
			}
		}
	},	
	methods: {
		...mapActions(["setLoaded", "fetchData", "setScroll"]),

		leave: (node, done) => {			
			gsap.to(node, { 
				xPercent: -100, 
				duration: 1.8,
				ease: "power3.inOut",
				onComplete: done
			});

			gsap.to(".preload-heading", {
				xPercent: 100,
				ease: "power3.inOut", 
				duration: 1.8				
			});
			gsap.to(".preload-text", {
				xPercent: 100,
				ease: "power3.inOut", 
				duration: 1.8				
			})
		},

		// After "Wipe" transition
		afterLeave: function() {
			this.setScroll(true);
		}	
	},

	computed: mapGetters(["loaded", "work"]),

	// Watch changes to 'work' store
	watch: {
		work: function(data) {
			const loadIndex = data.length;
			let tempIndex = 0;

			// Preload Images
			data.forEach( item => {
				let img = new Image();
				img.src = require("@/assets/" + item.img);
				img.onload = ()=> {					
					tempIndex++;

					// Finish loading
					if(tempIndex >= loadIndex) 
						this.preload.images = true; // true
				}				
			});			
		},

		preload: {
			deep: true,
			handler: function(data) {
				if(data.images && data.loadCycle) {
					setTimeout(()=>{
						this.setLoaded(true);
					}, 500);
				}
			}			
		}
	},

	// Lifecycles	
	created() {
		this.fetchData();		
	},
	mounted() {
		const CHAR_DELAY = .28;		

		setTimeout( ()=> { window.scrollTo(0, 0); }, 250)
		

		// Name text
		const name = new SplitText(".preload-heading", {
			type: "chars",
			charsClass: "char"
		});
		name.chars.forEach((element, index) => {			
			element.style.transitionDelay = (CHAR_DELAY + (.03 * index)) + "s";
		});	
		setTimeout( ()=> {
			this.ready = true;
		}, 750);

		// Loading text
		gsap.fromTo(".preload-text", { 
			autoAlpha: 0, yPercent: 100 
		}, { 
			autoAlpha: 1, yPercent: 0, duration: 1, delay: 1.9, ease: "power2.out",
			onComplete: ()=> {
				this.preload.loadCycle = true;
			}
		});

		// Test
		/*setTimeout( ()=> {
			this.setLoaded(true);
		}, 3200);*/	

		//console.log(this.work);
	}	
}
</script>

<style scoped lang="scss">
@import "../styles/variables.scss";
@import "../styles/mixins.scss";

.loader {	
	position: absolute;
	top: 0;
	left: 0;
	width: 100vw;
	height: 300vh;    
	text-align: left;
	background-color: map-get($colors, 'prime-light');
	will-change: transform;
	color: map-get($colors, 'prime-dark');	
	overflow: hidden;
	z-index: 2;	
}

.loader-container {
	left: 8.33vw;
	padding-left: 0;
}

.preload-heading {
	/*position: relative;
	mix-blend-mode: difference;
	z-index: 2;	
	font-size: 80px;
	font-size: 2.583vw;*/	

	/deep/ .char {
		/*display: inline-block;
		transform-origin: center center .4em;
		transform: rotate3d(1,-.3,0,90deg);
		transform-style: preserve-3d;
		transition: transform 1.5s cubic-bezier(.19,1,.22,1), opacity 1s;
		opacity: 0;*/

		&:nth-child(6) {
			letter-spacing: -.15vw;
		}
	}	
}

.preload-text {	
	opacity: 0;	
	/*padding-left: .23vw;
	font-size: .833vw;*/

	&.cycle {
		animation: loading 1s linear infinite;
	}
}
/*
.ready {
	.preload-heading {
		/deep/ .char {
			transform: rotate3d(0,0,0,90deg);
			opacity: 1;
		}
	}	
}*/

@include phone {
	.preload-heading {
		/deep/ .char:nth-child(6) {
			letter-spacing: -.6vw;
		}
	}
}

@include tablet {
	.preload-heading {
		/*font-size: 6.583vw;*/

		/deep/ .char:nth-child(6) {
			letter-spacing: -.5vw;
		}
	}
	/*.preload-text {	
		font-size: 3vw;
		padding-left: 0.6vw;
	}*/
}

@keyframes loading{
	50% {
		opacity:0
	}
}
</style>
